export enum Modules {
    Onboarding,
    Corporate,
    Invoicing,
    Risk
}
